<div class="row">
    <div class="col-md-12 col-lg-12 pr-0">
        <globalservicios></globalservicios>
    </div>
    <div class="col-md-6 col-lg-4 pr-0 h-100">
        <globalinformaciongeneral></globalinformaciongeneral>
        <div class="mt-3">
            <globalasesores></globalasesores>
        </div>
    </div>
    <div class="col-md-6 col-lg-4 pr-0">
        <globalventasvendedor></globalventasvendedor>
    </div>
    <div class="col-md-12 col-lg-4 mt-2">
        <div class="row h-100">
            <div class="row text-start">
                <h2 class="titleppal">Un mundo de servicios</h2>
            </div>
            <div class="col-md-6 col-lg-12 col-12 p-3 pe-0">
                <globalresumenafiliados></globalresumenafiliados>
            </div>
            <div class="col-md-6 col-lg-12 col-12 pe-0">
                <globalresumenasistencias></globalresumenasistencias>
            </div>
        </div>
    </div>
</div>